/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { ExternalStyles, Text, Theme, useTheme } from 'bold-ui'
import { ReactNode } from 'react'

import { ConsultaSeguimentoArrowDown } from './ConsultaSeguimentoArrowDown'

interface ConsultaSeguimentoIndicatorStepProps {
  text: string | ReactNode
  style?: ExternalStyles
}

export function ConsultaSeguimentoIndicatorStep(props: Readonly<ConsultaSeguimentoIndicatorStepProps>) {
  const { text, style } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <div css={[styles.root, style]}>
      <div css={styles.line} />
      <Text style={styles.text}>{text}</Text>
      <ConsultaSeguimentoArrowDown />
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  root: css`
    display: grid;
    justify-self: center;
    justify-items: center;
    color: ${theme.pallete.primary.main};
    width: 40%;
  `,
  line: css`
    width: 2px;
    height: 2rem;
    background: ${theme.pallete.primary.c60};
  `,
  text: css`
    color: inherit;
    text-align: center;
    padding: 0.5rem 1rem;
    border: 1px solid ${theme.pallete.divider};
    border-radius: 0.25rem;
  `,
})
